import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'
const QUERIES_DEFAULT_VALUE = []

export default {
  namespaced: true,
  state: {
    queries: QUERIES_DEFAULT_VALUE,
    fetching: true
  },
  mutations: {
    setQueries (state, queries) {
      state.queries = queries || QUERIES_DEFAULT_VALUE
    }
  },
  actions: {
    fetch ({ state, commit }, { idParent, withPriority }) {
      state.fetching = true

      apiService.getProjectPriorityPositions(idParent, withPriority)
        .then(response => {
          commit('setQueries', response.data.queries)
          window.vue.$emit('projectPriorityPositionsLoaded')

          state.fetching = false
        })
        .catch(() => {
          commit('setQueries')

          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию по позициям по приоритетным запросам за текущий месяц.'
          })
        })
    }
  },
  getters: {
    getNotEmptyUpdatesDates: state => sengine => {
      const dates = []

      if (state.queries.length > 0) {
        for (const date in state.queries[0].positions[sengine]) {
          if (state.queries[0].positions[sengine][date] !== null) {
            dates.push(date)
          }
        }
      }

      return dates
    },
    getQueryPosition: (state) => (query, date, sengine) => {
      if (!query.positions[sengine]) {
        return null
      }

      return query.positions[sengine][date]
    },
    getQueryPositionsDiff: (state, getters) => (query, dateFrom, dateTo, sengine) => {
      const from = getters.getQueryPosition(query, dateFrom, sengine)
      const to = getters.getQueryPosition(query, dateTo, sengine)

      return !isNaN(from) && !isNaN(to) && from !== to
        ? from - to
        : 0
    }
  }
}
